export default __webpack_public_path__ + "static/media/sydney.f733eb00.png";